import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);
  
  const getIcon = () => {
    switch (type) {
      case 'success':
        return FiIcons.FiCheckCircle;
      case 'error':
        return FiIcons.FiAlertCircle;
      case 'warning':
        return FiIcons.FiAlertTriangle;
      case 'info':
        return FiIcons.FiInfo;
      default:
        return FiIcons.FiInfo;
    }
  };
  
  const getStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100 border-green-400 text-green-700';
      case 'error':
        return 'bg-red-100 border-red-400 text-red-700';
      case 'warning':
        return 'bg-yellow-100 border-yellow-400 text-yellow-700';
      case 'info':
        return 'bg-blue-100 border-blue-400 text-blue-700';
      default:
        return 'bg-blue-100 border-blue-400 text-blue-700';
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        className={`fixed bottom-4 right-4 z-50 border px-4 py-3 rounded-lg shadow-lg flex items-center ${getStyles()}`}
      >
        <SafeIcon icon={getIcon()} className="mr-2 text-lg" />
        <span>{message}</span>
        <button 
          onClick={onClose}
          className="ml-3 text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <SafeIcon icon={FiIcons.FiX} />
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Toast;